import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { ResourceFormValues } from 'src/models/Resource.model';
import ResourceForm from '../Layouts/ResourceForm';
import { useAddResourceMutation } from 'src/services/ResourceServices';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddResourceFormWrapper = ({ onClose }: Props) => {
  const [addResource] = useAddResourceMutation()
  // Form Initial Values
  const initialValues: ResourceFormValues = {
    resourceType :'' ,
    imageUrl : '' ,
    dataDescription : '',
    title :'' ,
}
  
  // Validation Schema
  const validationSchema = object().shape({
    resourceType: object().required('Please enter name'),
    title: string().required('Please enter title '),
  });

  // Handle Submit
  const handleSubmit = (
    values: ResourceFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ResourceFormValues>
  ) => { 

    const formattedValues ={
      title: values?.title ,
      description: values?.dataDescription,
      imageUrl:values?.imageUrl,
      type: values?.resourceType?.value ,
  }

    addResource(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
            resetForm();
            onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ResourceForm formikProps={formikProps} onClose={onClose} formType='ADD' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddResourceFormWrapper;